import localStorageUtil from './localStorage';

export const getUserFromLocalStorage = () => {
  return localStorageUtil.getItem('userDetails') || null;
};

export const getCurrentUserRole = () => {
  const user = getUserFromLocalStorage();
  return user?.roles?.[0] || null;
}; 